module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/044-latvia-6931b6aeb435e17f50574434bba330d5.svg";